import api from '../../api';

const operationKey = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `ce-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

const keyed = (key) => ({ headers: { 'Idempotency-Key': key } });

export const createCommunityExperienceApi = (client = api) => Object.freeze({
  claimDashboardInvitation: (locale, key = operationKey()) =>
    client.post('/community-experiences/solicitation/present', { locale }, keyed(key)),
  respondToDashboardInvitation: (body, key = operationKey()) =>
    client.post('/community-experiences/solicitation/respond', body, keyed(key)),
  create: (body, key = operationKey()) => client.post('/community-experiences', body, keyed(key)),
  listOwn: () => client.get('/community-experiences'),
  readOwn: (contributionId) => client.get(`/community-experiences/${contributionId}`),
  addIdentityChoice: (contributionId, body, key = operationKey()) =>
    client.post(`/community-experiences/${contributionId}/identity-choices`, body, keyed(key)),
  authorize: (contributionId, body, key = operationKey()) =>
    client.post(`/community-experiences/${contributionId}/authorizations`, body, keyed(key)),
  withdraw: (contributionId, body, key = operationKey()) =>
    client.post(`/community-experiences/${contributionId}/withdraw`, body, keyed(key)),
  withdrawCollectionConsent: (contributionId, body, key = operationKey()) =>
    client.post(`/community-experiences/${contributionId}/collection-consent/withdraw`, body, keyed(key)),
});

export const communityExperienceApi = createCommunityExperienceApi();
export const createCommunityExperienceOperationKey = operationKey;
